import { Module } from 'vuex';
import { RootState } from '@/store/rootState';
import { RelayState } from './relayState';
import mutations from './mutations';
import actions from './actions';
import state from './state';
import getters from './getters';

const settings: Module<RelayState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state,
    getters,
};

export default settings;
